/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  // {
  //   name: 'EpidemicProtocol',
  //   path: '/epidemic-protocol/index', // 代码下架，可能不再使用
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "EpidemicProtocol" */ '@/views/epidemic-protocol/index'
  //     ),
  //   meta: { title: '防疫协议' },
  // },
];
